import PropTypes from "prop-types";
import React from "react";

import EditDestinationForm from "v2/components/responsive/EditDestinationForm";

const EditDestinationPage = (props, context) => {
  const {location: {query}, params: {date, id, routeId}, router} = context;
  return (
    <EditDestinationForm
      onCancel={(evt) => {
        evt.preventDefault();
        router.push({
          pathname: `/${date}/${routeId}/${id}`,
          query,
        });
      }} />
  );
};

EditDestinationPage.contextTypes = {
  location: PropTypes.object,
  params: PropTypes.shape({
    date: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    routeId: PropTypes.string.isRequired,
  }),
  router: PropTypes.object,
};

export default EditDestinationPage;



/** WEBPACK FOOTER **
 ** ./src/app/v2/pages/EditDestinationPage.js
 **/